/* eslint-disable */
import {
  DELIVERY_ORDER_STATUS_ALL,
  DELIVERY_ORDER_STATUS_COMPLETED,
  DELIVERY_ORDER_STATUS_DELIVERED,
  DELIVERY_ORDER_STATUS_LIVE,
  DELIVERY_ORDER_STATUS_SCHEDULED,
} from '../../Constants/Delivery/Delivery.constants';
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the given `status` is invalid
 * @export
 * @class DeliveryInvalidOrderStatusError
 * @extends {Error}
 */
export class DeliveryInvalidOrderStatusError extends Error {
  /**
   * Creates an instance of DeliveryInvalidOrderStatusError
   * @param {string} message The Error `message`
   * @memberof DeliveryInvalidOrderStatusError
   */
  constructor(message) {
    super(message);
    this.name = `DeliveryInvalidOrderStatusError`;
  }
}

/**
 * Called when the given `status` is invalid
 * @param {any} status The invalid `status`
 * @returns {never} never
 */
const throwDeliveryInvalidOrderStatusError = (status) => {
  throw new DeliveryInvalidOrderStatusError(
    stripIndent(`
    Expected "status" to be one of
      "${DELIVERY_ORDER_STATUS_ALL}"
      "${DELIVERY_ORDER_STATUS_COMPLETED}"
      "${DELIVERY_ORDER_STATUS_DELIVERED}"
      "${DELIVERY_ORDER_STATUS_LIVE}"
      "${DELIVERY_ORDER_STATUS_SCHEDULED}"
    Got: "${status}".
    `),
  );
};

export default throwDeliveryInvalidOrderStatusError;
